<template>
  <main-layout
    class="insure"
    :page-title="title"
    custom-back
    @listen-back="handleClickBack"
  >
    <div slot="main-content" class="main-content">
      <component
        :is="currentStep"
        @prev-step="goPrevStep"
        @next-step="goNextStep"
      ></component>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import ChooseLand from "@/views/ruralInsurance/infoWrite/ChooseLand/index";
import VerifyList from "@/views/ruralInsurance/infoWrite/VerifyList/index";
import Form from "@/views/ruralInsurance/infoWrite/Form/index";
import { getStorage } from "@/utils/storage";
import {
  getInsureId,
  getRuralInsurableLandList,
} from "@/api/request/snkd.produce";
export default {
  components: { MainLayout, ChooseLand, VerifyList, Form },
  data() {
    return {
      title: "险种名称",
      currentStep: "ChooseLand", // 当前步骤显示的组件

      insureId: null, // 保险 id
      companyId: null,
      farmId: null,
    };
  },
  async mounted() {
    // 获取企业，农场id
    const farminfo = getStorage("FARMINFO");
    if (farminfo) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    // 获取保险 id，用于查询可投保地块
    const insure = await getInsureId();
    if (insure.respCode == 0) {
      this.insureId = insure.obj.list[1].id;
      this.title = insure.obj.list[1].insureName;
      this.$store.commit("ruralInsure/setInsureId", this.insureId);
    }

    this.initPageData();
  },
  methods: {
    // 获取地块列表信息，初始化数据
    async initPageData() {
      const ajaxParams = {
        insureId: this.insureId,
        companyId: this.companyId,
        farmId: this.farmId,
      };
      const res = await getRuralInsurableLandList(ajaxParams);
      if (res.respCode == 0) {
        if (res.obj && res.obj.length) {
          this.processSelectData(res.obj);
          this.processShowLandList(res.obj);
        }
      }
      // 请求结束，loading 状态设为 false
      this.$store.commit("ruralInsure/changeLoadingStatus", false);
    },
    // 处理选择器数据
    processSelectData(obj) {
      const landGroupIds = [],
        landGroupList = [];

      let hasNoGroup = false;
      obj.forEach((item) => {
        // 处理地块分组
        if (!landGroupIds.includes(item.coLandVO.landGroupId)) {
          if (item.coLandVO.landGroupId == 0) {
            hasNoGroup = true;
          } else {
            landGroupList.push({
              id: item.coLandVO.landGroupId,
              landGroupName: item.coLandVO.landGroupName,
            });
          }
          landGroupIds.push(item.coLandVO.landGroupId);
        }
      });
      // 地块编组按照id降序排序
      landGroupList.sort((a, b) => b.id - a.id);

      if (hasNoGroup) {
        landGroupList.push({
          id: 0,
          landGroupName: "未编组地块",
        });
      }
      this.$store.commit("ruralInsure/setLandGroupList", landGroupList);
    },
    // 处理保存地块数据
    processShowLandList(data) {
      data.forEach((item) => {
        item.select = false;
        item.landId = item.coLandVO.id;
      });
      this.$store.commit("ruralInsure/setLandList", data);
    },
    goPrevStep(comp) {
      this.currentStep = comp;
    },
    goNextStep(comp) {
      this.currentStep = comp;
    },
    handleClickBack() {
      if (this.currentStep === "ChooseLand") {
        window.history.go(-1);
        // 退出投保页面时，清空一些状态
        this.$store.commit("ruralInsure/clearInsurePageStatus");
      } else {
        this.$confirm(
          "确定返回吗？返回后无法保存已填写和已选择的内容",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            customClass: "message-box-height",
          }
        )
          .then(() => {
            window.history.go(-1);
            // 退出投保页面时，清空一些状态
            this.$store.commit("ruralInsure/clearInsurePageStatus");
          })
          .catch(() => {
            console.log("已取消");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.insure {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
  }
}
::v-deep .common-page-header .title {
  font-size: 22px !important;
  width: 400px;
}
</style>
